/*=====================================
    中獎發票列表

    Author: Gray
    createtime: 2018 / 01 / 22
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
import filter from 'lodash/filter';
import classNames from "classnames";
import actionCreators from 'actions/creators';
import CupoyRouter from "components/commons/router/CupoyRouter";
import PagedList from 'components/commons/PagedList';
import PrizedInvoiceListHeader from './PrizedInvoiceListHeader';
import PrizedInvoiceListItem from './PrizedInvoiceListItem';

/*--------------------------
    Main Component
--------------------------*/
class PrizedInvoiceListView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            hasNoRecord: false,
            yearmonth: undefined,
            isFilterYearmonth: false,
        };

        this.onYearmonthChange = this.onYearmonthChange.bind(this);
        this.toggleIsFilterYearmonth = this.toggleIsFilterYearmonth.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.changeHasNoRecord = this.changeHasNoRecord.bind(this);
        this.renderFilterContent = this.renderFilterContent.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.init(this.props);
        this.getInvoicePrizeYearmonthList();
    }

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    // ------------------------------
    // init
    // ------------------------------
    init(props) {

        if (!props.match) {
            return;
        }

        const page = props.match.params.page;
        const location = props.location;
        const old_yearmonth = this.state.yearmonth;
        var yearmonth = undefined;
        var isFilterYearmonth = false;
        const old_hasNoRecord = this.state.hasNoRecord;
        var hasNoRecord = false;
        var isChange = false;

        if(location && location.search) {
            const querys = parse(location.search.substr(1));
            yearmonth = querys.yearmonth;

            if(yearmonth !== old_yearmonth) {
                isChange = true;
            }

            isFilterYearmonth = !!yearmonth;

            hasNoRecord = !!querys.hasNoRecord;

            if(hasNoRecord && hasNoRecord !== old_hasNoRecord) {
                isChange = true;
            }
        }

        isChange = isChange || this.state.page !== page;

        if (!isChange) {
            return;
        }

        this.setState({
            page: page,
            yearmonth: yearmonth,
            isFilterYearmonth: isFilterYearmonth,
            hasNoRecord: hasNoRecord,
        });
    }

    // ------------------------------
    // 取得中獎發票存在的期別列表 
    // ------------------------------
    getInvoicePrizeYearmonthList() {

        if(!Array.isArray(this.props.yearmonthList) || this.props.yearmonthList.length === 0) {
            this.props.prizedInvoiceActions.getInvoicePrizeYearmonthList();
        }
    }

    // ------------------------------
    // 期別更動
    // ------------------------------
    onYearmonthChange(event) {

        var yearmonth = event.target.value;

        this.setState({
            yearmonth: yearmonth,
            isFilterYearmonth: !!yearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 切換過濾期別
    // ------------------------------
    toggleIsFilterYearmonth(isFilterYearmonth) {

        this.setState({
            isFilterYearmonth: isFilterYearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 任何過濾條件變動
    // ------------------------------
    onFilterChange() {

        const {
            yearmonth,
            isFilterYearmonth,
            hasNoRecord,
        } = this.state;

        var querys = {};

        if(isFilterYearmonth) {
            querys.yearmonth = yearmonth;
        }

        if(hasNoRecord) {
            querys.hasNoRecord = hasNoRecord;
        }

        const statename = CupoyRouter.STATES.PRIZEDINVOICE_LIST;
        const params = {
            page: 1,
        };

        this.props.webActions.cupoyStateGo(statename, params, querys);
    }

    // ------------------------------
    // 切換顯示是否為代拋發票
    // ------------------------------
    changeHasNoRecord(hasNoRecord) {

        if(hasNoRecord === this.state.hasNoRecord) {
            return;
        }

        this.setState({
            hasNoRecord: hasNoRecord,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // render filter區塊
    // ------------------------------
    renderFilterContent(querys) {

        const {
            yearmonth,
        } = this.state;

        const {
            yearmonthList,
        } = this.props;

        return (
            <div className="form">
                <table className="form-table">
                    <tbody>
                        <tr className="form-row">
                            <td className="form-col label-text">發票期別</td>
                            <td className="form-col">
                                <div className="form-select fileter-large-content">
                                    <select value={yearmonth} onChange={(event) => this.onYearmonthChange(event)}>
                                        <option value={''} key={''}>---</option>
                                        {yearmonthList.map((_yearmonth, index)=> {
                                            return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                        })}
                                    </select>
                                    <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { page, hasNoRecord } = this.state;
        const { location, pageLen, totalCount, yearmonthList } = this.props;
        const num_page = Number(page);
        
        var querys = {};

        if(location && location.search) {
            querys = parse(location.search.substr(1));
        }

        var renderFilterContent = null;

        if(yearmonthList.length > 0) {
            renderFilterContent = () => {
                return this.renderFilterContent(querys);
            }         
        }

        return (
            <div id="prizedInvoice">
                <div className="header-bar mix">
                    <div className="tabs">
                        <h2 className="title">中獎發票列表</h2>
                        <ul className="tab-list">
                            <li 
                                className={classNames("tab-item", {
                                   'active': !hasNoRecord,
                                })}
                                onClick={() => this.changeHasNoRecord(false)}
                            >
                                <a>捷可印發票</a>
                            </li>
                            <li 
                                className={classNames("tab-item", {
                                   'active': hasNoRecord,
                                })}
                                onClick={() => this.changeHasNoRecord(true)}
                            >
                                <a>代拋發票</a>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <PagedList
                    page={num_page}
                    pageLen={pageLen}
                    totalCount={totalCount}
                    colspan={4}
                    pageStateName={CupoyRouter.STATES.PRIZEDINVOICE_LIST}
                    querys={querys}
                    getListItemFrom={(start, querys) => {
                        return this.props.prizedInvoiceActions.getPrizedInvoiceList({ 
                            start: start,
                            yearmonth: querys.yearmonth,
                            hasNoRecord: querys.hasNoRecord,
                        });
                    }}
                    getItemsInRanage={(start, end) => {
                        return filter(this.props.prizedInvoiceList, (item, index) => {
                            return Number(index) >= start && Number(index) < (end);
                        });
                    }}
                    renderItemHeaderRow={(item, index) => {
                        return <PrizedInvoiceListHeader />;
                    }}
                    renderItemRow={(item, index, start) => {
                        return <PrizedInvoiceListItem
                            key={index}
                            item={this.props.prizedInvoices[item]}
                            start={start}
                            index={start + index + 1}
                        />;
                    }}
                    renderFilterContent={renderFilterContent}
                />
            </div>
        );
    }

}

const mapStateToProps = function (state) {
    return {
        prizedInvoiceList: state.prizedInvoice.prizedInvoiceList,
        prizedInvoices: state.prizedInvoice.prizedInvoices,
        pageLen: state.prizedInvoice.pageLen,
        totalCount: state.prizedInvoice.totalCount,
        yearmonthList: state.prizedInvoice.yearmonthList,
    };
};

const mapActionToProps = function (dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        prizedInvoiceActions: bindActionCreators(actionCreators.prizedInvoiceActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(PrizedInvoiceListView);


// WEBPACK FOOTER //
// ./src/components/prizecheck/PrizedInvoiceListView.jsx